import axios from "axios";
import { keycloak } from "../keycloak";
import { EmployeeTypology, F24Typology, FinancialStatementsTypology, FindAllFiscalDocumentDTO, FiscalDocumentFilters, FiscalDocumentResponseDTO, UnseenFiscalDocumentsDTO } from "./dto";
import { FiscalDocumentService } from "./service";

export class FiscalDocumentServiceImpl implements FiscalDocumentService {

    public findAllFiscalDocuments(filters: FiscalDocumentFilters): Promise<FindAllFiscalDocumentDTO> {
        let url: string =
            "/api/fiscal-documents?companyId=" + filters.companyId +
            "&itemsPerPage=" + filters.itemsPerPage +
            (filters.fileName !== '' ? '&name=' + filters.fileName : '') +
            "&page=" + filters.page +
            (filters.month !== undefined && filters.month !== '' ? '&referenceMonth=' + filters.month : '') +
            (filters.year !== undefined ? '&referenceYear=' + filters.year : '') +
            (filters.status !== '' ? '&status=' + filters.status : '') +
            "&type=" + filters.type +
            (filters.typology !== ('' as FinancialStatementsTypology | '' as F24Typology | '' as EmployeeTypology) ? '&typology=' + filters.typology : ('' as FinancialStatementsTypology | '' as F24Typology | '' as EmployeeTypology))
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findByIdFiscalDocument(id: string): Promise<FiscalDocumentResponseDTO> {
        let url: string = "/api/fiscal-documents/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public unseenFiscalDocuments(id: string): Promise<UnseenFiscalDocumentsDTO> {
        let url: string = "/api/companies/unseenFiscalDocuments/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}

